var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueNotification',{ref:"vueNotification",attrs:{"classes":"Notification","group":_vm.group,"position":_vm.position,"duration":_vm.duration,"speed":_vm.speed,"max":_vm.max,"reverse":_vm.reverse,"width":_vm.width},scopedSlots:_vm._u([{key:"body",fn:function(props){return [_vm._t("default",null,null,props)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }